export default __webpack_public_path__ + "static/media/secure-filed.98a160f1.png";